import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, TruckIcon, AwardIcon, HeadphonesIcon } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: AwardIcon,
    title: 'Authorized Since 2017',
    description: 'Trusted partnerships with leading brands'
  }, {
    icon: ShieldCheckIcon,
    title: '100% Authentic',
    description: 'Direct from manufacturers'
  }, {
    icon: TruckIcon,
    title: 'Fast Fulfillment',
    description: 'Regional warehousing in UAE'
  }, {
    icon: HeadphonesIcon,
    title: 'Dedicated Support',
    description: 'Account management included'
  }];
  return <section className="py-16 px-6 bg-white border-b border-gray-100" data-id="element-270">
      <div className="max-w-6xl mx-auto" data-id="element-271">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-272">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-273">
              <div className="w-14 h-14 mx-auto mb-3 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-xl flex items-center justify-center" data-id="element-274">
                <badge.icon className="w-7 h-7 text-white" data-id="element-275" />
              </div>
              <h3 className="font-bold text-[#0B1220] mb-1" data-id="element-276">{badge.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-277">{badge.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}